import { motion } from "framer-motion";
import { KeyRound, Wrench, Hammer, ShieldCheck, Truck, Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";

const icons = { KeyRound, Wrench, Hammer, ShieldCheck, Truck };

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative pt-28 md:pt-40 pb-20 md:pb-28 surface-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E63946]">Our Services</p>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-steel">
            Complete property &amp; security solutions
          </h2>
          <p className="mt-4 text-gray-400">
            One trusted local team for locks, repairs, joinery, security and clearances —
            for homes and businesses across Buckinghamshire.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, idx) => {
            const Icon = icons[s.icon];
            return (
              <motion.div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.06 }}
                className="group relative rounded-2xl card-grey elev border border-white/10 overflow-hidden hover:-translate-y-1.5 hover:border-white/25 transition-all duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2a2a2f] via-[#2a2a2f]/30 to-transparent" />
                  <span className="absolute bottom-3 left-3 flex items-center justify-center w-11 h-11 rounded-xl bg-[#E63946] text-white shadow-[0_0_18px_rgba(230,57,70,0.4)]">
                    <Icon className="w-5 h-5" />
                  </span>
                  <ArrowUpRight className="absolute top-3 right-3 w-5 h-5 text-white/0 group-hover:text-white/70 transition-colors" />
                </div>
                <div className="relative p-6">
                  <h3 className="font-heading text-lg font-semibold text-white">{s.title}</h3>
                  <ul className="mt-4 space-y-2">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-center gap-2 text-sm text-gray-300">
                        <Check className="w-4 h-4 text-[#E63946] shrink-0" strokeWidth={2.5} /> {it}
                      </li>
                    ))}
                  </ul>
                  <button
                    data-testid={`service-quote-${s.key}`}
                    onClick={() => scrollTo("contact")}
                    className="mt-6 w-full rounded-full border border-white/15 text-white hover:bg-[#E63946] hover:border-[#E63946] text-sm font-semibold py-2.5 transition-colors"
                  >
                    Get a Quote
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
